import type { LandingDict } from './en';

const ptBR: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "Criar app", org: "My Org", pricing: 'Preços', privacy: "Privacidade", contact: "Contato", language: 'Idioma' },
  hero: {
    titlePre: 'Sua central\n',
    titleMark: 'de IA local.',
    titlePost: '',
    sub: "Transforme conhecimento especializado, planilhas e reuniões em respostas, gráficos e apresentações. Nada sai do seu Mac.",
    watch: "Assista ao vídeo de 2 min",
    pill: "Versão mais recente",
    chip: "Wi‑Fi desligado · 0 bytes enviados",
    badges: { offline: "Funciona offline", server: "Seu servidor, não o nosso", free: "Grátis para começar" },
    reqs: 'Requer um Mac com Apple Silicon · Mínimo de 16 GB de memória · Com 32 GB ou mais, você usa os modelos recomendados maiores',
  },
  stats: {
    free: 'Grátis',
    freeSub: 'Todos os Chat Apps, downloads de modelos e atualizações. Sempre.',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'bytes enviados à nuvem quando a IA roda neste Mac',
    langsSub: 'idiomas de interface, do português ao 日本語',
  },
  film: { kicker: 'O filme', title: 'Veja o Estha em ação.', watchOnYouTube: 'Assistir no YouTube', trouble: 'Não está carregando? Assista no YouTube ↗' },
  overview: {
    kicker: 'Um app, quatro jeitos de trabalhar',
    title: 'Do chat aos agentes,\naté apps para toda a equipe.',
    explore: 'Explorar',
    chat: { title: 'Chat Apps', desc: 'Especialistas de IA fundamentados em bases de conhecimento selecionadas — livros didáticos, manuais e conhecimento especializado.', tag: 'Sempre grátis' },
    agentic: { title: 'Agentic Apps', desc: 'Agentes de IA orientados a tarefas que cuidam de trabalhos complexos do início ao fim.', tag: '{n} e vem mais por aí' },
    build: { title: "Criar app", desc: 'Transforme seus próprios materiais em um Chat App com o Quick Bot ou monte fluxos na tela do Playground.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'O espaço de apps da sua organização, com a sua marca, apps revisados e acesso controlado.', tag: 'Enterprise' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'IA especialista, com base em conhecimento real.',
    freePill: 'Sempre grátis',
    lede: 'Cada Chat App vem com a própria base de conhecimento, indexada direto no seu Mac.',
    feats: {
      kb: { title: 'Bases de conhecimento locais', desc: 'Ao instalar um app, a base de conhecimento dele é criada no seu Mac — as respostas vêm de material selecionado.' },
      files: { title: 'Use seus próprios arquivos', desc: 'Anexe imagens, PDF, DOCX, TXT ou MD. Documentos longos usam recuperação inteligente.' },
      browse: { title: 'Explore, fixe, favorite', desc: 'Categorias de Avaliação a Carreira, selos NEW nos apps recém-chegados e ⌘K para buscar tudo.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} Agentic Apps.\nE vem mais por aí.',
    lede: 'De uma planilha, um PDF, uma gravação ou uma ideia até um gráfico, uma apresentação, um documento ou um protótipo prontos — com privacidade, no seu Mac.',
    seeThem: 'Veja como funcionam',
  },
  build: {
    kicker: 'Criar app',
    title: 'Crie seu próprio Chat App.\nNo seu Mac.',
    lede: 'Transforme seus arquivos em um Chat App — indexado localmente e publicado quando você quiser.',
    quick: {
      badge: 'Recomendado',
      desc: 'Envie uma base de conhecimento e escreva um prompt de sistema, depois publique. Ótimo para transformar materiais em um bot de perguntas e respostas rapidamente.',
      items: ['Formulário de uma página, feito em poucos passos', 'Perguntas e respostas com base de conhecimento prontas para uso', 'Modelos de prompt integrados para inspiração'],
    },
    advanced: {
      title: 'Avançado · Playground',
      desc: 'Editor visual de nós para compor livremente vários nós, ramificações, AB test e roteamento por palavra-chave.',
      items: ['Tela de nós', 'Vários nós / ramificação / AB test', 'Campos detalhados e depuração'],
    },
    guideTitle: 'Um guia de IA local ao seu lado.',
    guideText: 'Diga o que você quer que o app faça e ele mostra quais nós arrastar e como conectá-los. A criação de apps está incluída no Premium.',
  },
  private: {
    kicker: 'Privado por design',
    title: "Sem nuvem para seus dados.\nSem rastreamento do seu trabalho.",
    lede: "Você decide onde a IA roda. Por padrão, o Estha escolhe o modelo certo para cada recurso — e você pode trocar de modelo quando quiser no app.",
    boundary: "Limite dos dados = sua rede",
    local: { title: 'Neste Mac', desc: 'Totalmente off-line, nada sai deste dispositivo. Roda os modelos usando a memória deste computador.', best: 'Ideal para Macs com bastante memória' },
    server: { title: 'No meu Estha Server', desc: 'Transfira o trabalho pesado para um Mac mais potente da sua rede e mantenha este Mac leve.', best: 'Ideal para notebooks e Macs com pouca memória' },
    cluster: { desc: 'Conecte-se a um cluster Mac Studio para transferir inferências pesadas, mantendo seus dados na sua própria infraestrutura.', best: 'Encontra automaticamente os nós Estha Studio Master na sua rede' },
    models: {
      every: 'Roda em qualquer Mac compatível',
      whisper: "Whisper para transcrição",
      recommended: 'Os modelos recomendados',
      larger: "Modelos Qwen e Gemma maiores",
      vision: "Modelos de visão para imagens",
      open: 'Modelos abertos, otimizados para Apple Silicon',
      openItems: ['Baixe e troque de modelo no próprio app', 'Modelos dedicados para código e embeddings', 'Downloads de modelos sempre grátis'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'O espaço de apps de IA da sua organização.',
    lede: 'Uma seção com a marca da sua organização dentro do Estha, reunindo os apps que ela revisou para as pessoas dela.',
    signIn: 'Entrar no My Org Admin',
    talk: 'Fale com a equipe Estha',
    feats: {
      review: { title: 'Revisão antes de publicar', desc: 'Todo app novo, atualização ou remoção passa por um administrador. Rejeições sempre vêm com um parecer por escrito.' },
      access: { title: 'Acesso por grupo ou pessoa', desc: 'Defina exatamente quem vê cada app — por departamento, equipe ou pessoa.' },
      brand: { title: 'Sua marca, dentro do app', desc: 'Nome da organização, mensagem de boas-vindas, logo, banner e cor do tema — com prévia antes de entrar no ar.' },
    },
  },
  pricing: {
    kicker: 'Assinatura',
    title: 'Comece grátis. Desbloqueie tudo quando quiser.',
    free: { name: 'Grátis', sub: 'Sempre grátis.', items: ["Todos os Chat Apps", 'Processamento de Documentos, grátis para sempre', 'Downloads de modelos, software e atualizações — sempre gratuitos'] },
    premium: {
      name: 'Premium', flag: 'Teste grátis de 14 dias', firstYear: 'no primeiro ano',
      sub: 'Depois, US$ 30/ano. Comece com um teste grátis de 14 dias após verificar seu e-mail.',
      items: ['Tudo do plano Grátis', 'Todos os Agentic Apps atuais e futuros', 'Criador de Chat Apps — crie, edite, visualize, salve e publique chatbots locais'],
      cta: 'Comece o teste no app',
    },
    enterprise: {
      name: 'Enterprise', price: 'Vamos conversar', sub: 'Para organizações que vão levar o Estha às suas equipes.',
      items: ['Tudo do plano Premium', 'Chat Apps e Agentic Apps personalizados para sua equipe', 'Capacidade do aplicativo Estha Server', 'Espaço de apps My Org e My Org Admin'],
    },
  },
  faq: {
    title: 'Bom saber\nantes de baixar.',
    spec: { chip: 'Chip', memory: 'Memória', memMin: 'Mínimo de 16 GB', memRec: '32 GB ou mais para os modelos recomendados', languages: 'Idiomas', langsVal: '13 idiomas de interface', version: 'Versão mais recente' },
    qa: [
      { q: 'Alguma coisa sai do meu Mac?', a: 'Quando a IA roda neste Mac, tudo funciona off-line — nada sai do computador. Se você escolher um Estha Server ou um cluster Mac Studio, o trabalho vai apenas para essa máquina, dentro da sua própria rede.' },
      { q: "O que precisa de conexão com a internet?", a: "Pouca coisa: login e verificação de e-mail para o teste Premium, download de modelos e busca por atualizações. Seus prompts, arquivos e resultados nunca são enviados — depois que o modelo é baixado, a IA funciona totalmente offline." },
      { q: 'O que é grátis e o que é Premium?', a: 'Todos os Chat Apps, o Processamento de Documentos, os downloads de modelos e as atualizações são grátis. O Premium libera todos os Agentic Apps atuais e futuros, além do criador de Chat Apps, com teste grátis de 14 dias.' },
      { q: 'Quais modelos de IA ele usa?', a: 'Modelos de código aberto líderes, como Qwen e Gemma, além do Whisper para transcrição, rodando com o motor MLX da Apple. Você baixa e troca de modelo dentro do app.' },
      { q: 'Posso criar meu próprio app?', a: 'Sim. Com o Quick Bot, você transforma até três arquivos em um Chat App com base de conhecimento em poucos passos; com a tela de nós do Playground, cria ramificações, AB tests e quizzes. Um guia de criação local ajuda você no caminho.' },
      { q: 'Como uma organização implanta o Estha?', a: 'No Enterprise, os administradores gerenciam usuários e grupos no My Org Admin e revisam cada app antes da publicação; os membros ganham um espaço My Org com a marca da organização dentro do Estha. Fale com {email}.' },
    ],
  },
  final: { title: 'Pronto para rodar IA localmente?', reqs: 'Roda em qualquer Mac com Apple Silicon · Mínimo de 16 GB de RAM' },
  footer: {
    tagline: 'Sua central de IA local — no dispositivo, com tecnologia MLX, privada por design.',
    product: 'Produto', createApp: 'Criar app', pricing: 'Preços',
    orgs: "My Org", signIn: 'Entrar no My Org Admin',
    security: "Segurança", changelog: "Novidades", docs: "Documentação", support: "Suporte",
    company: 'Empresa', privacy: 'Política de Privacidade', terms: 'Termos de Serviço',
    rights: '© 2026 Estha. Todos os direitos reservados.',
  },
  proof: { press: "Na imprensa", voices: "O que as equipes dizem" },
  contact: {
    title: "Escreva para a equipe Estha", copy: "Copiar endereço de e-mail", copied: "Copiado",
    gmail: "Escrever no Gmail", mailApp: "Abrir no app Mail",
    subject: "Contato sobre o Estha for Mac",
  },
  share: {
    button: "Compartilhar", title: "Compartilhar o Estha",
    sub: "Escolha um card e publique — ou só mande o link.",
    style: "Card", size: "Tamanho",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Privacidade" },
    landscape: "Horizontal", portrait: "Vertical",
    shareImage: "Compartilhar imagem…", download: "Baixar imagem", copyImage: "Copiar imagem", copied: "Copiado",
    copyLink: "Copiar link", link: "Link", postTo: "Publicar em",
    email: "E-mail",
    text: "O Estha roda modelos de IA de código aberto inteiramente no seu Mac — privado, offline e gratuito.",
    cardCta: "Download grátis para Macs com Apple Silicon",
    close: "Fechar",
  },
  apps: {
    dataAnalyst: { name: 'Analista de Dados', description: 'Envie arquivos CSV/Excel e faça perguntas em linguagem natural. Gera gráficos, análises estatísticas e insights de dados automaticamente — tudo processado localmente no seu Mac.', tags: ['CSV / Excel', 'Gráficos Automáticos', 'Consulta em Linguagem Natural', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'Descreva o tema da sua apresentação e receba um deck de PowerPoint com estrutura profissional. Um pipeline de IA em várias etapas gera o roteiro, o conteúdo de cada slide e um arquivo .pptx refinado.', tags: ['Saída .pptx', 'Layout Automático', 'Pipeline de Várias Etapas'] },
    pdfReader: { name: 'Leitor de PDF', description: 'Abra um PDF e converse com ele. Cada resposta é fundamentada no documento, com citações clicáveis que levam ao trecho de origem exato — tudo processado localmente no seu Mac.', tags: ['Perguntas ao PDF', 'Citações verificáveis', 'Perguntar seleção', '100% local'] },
    documentProcessing: { name: 'Processamento de Documentos', description: 'Seu especialista completo em documentos. Crie posts de blog, textos para redes sociais, cláusulas jurídicas e documentos comerciais do zero. Edite e otimize arquivos existentes, traduza entre idiomas e revise o conteúdo quanto à qualidade — tudo de forma privada no seu Mac.', tags: ['Redação e Escrita', 'Edição e Otimização', 'Tradução', 'Revisão e Auditoria'] },
    meetingIntelligence: { name: 'Meeting Intelligence', description: 'Grave, transcreva e analise reuniões com IA. Gere automaticamente atas de reunião, itens de ação e decisões importantes — com total privacidade, sem que nenhum áudio saia do seu dispositivo.', tags: ['Transcrição', 'Atas de Reunião', 'Itens de Ação', '100% Privado'] },
    vibeCoding: { name: 'Vibe Coding: Protótipo', description: 'Crie prévias interativas com IA. Descreva uma interface em linguagem natural, obtenha um protótipo clicável e continue iterando. Gera um único arquivo .html autônomo, criado inteiramente no seu Mac.', tags: ['Arquivo .html único', 'Prévia interativa', 'Edição por clique', '100% local'] },
    translate: { name: "Traduzir", description: "Traduza textos e documentos Word, de texto ou Markdown com um glossário compartilhado que mantém seus termos consistentes, tudo processado localmente no seu Mac.", tags: ["Texto e documentos", ".docx / .txt / .md", "Glossário", "100% local"] },
  },
  screens: {
    chat: [
      { label: 'Explore a loja', caption: 'Explore, instale, fixe — sempre grátis' },
      { label: 'Instale', caption: 'A base de conhecimento é criada localmente na instalação' },
      { label: 'Pergunte', caption: 'Respostas fundamentadas no manual do app' },
    ],
    build: [
      { label: 'Criar app', caption: 'Quick Bot ou Avançado — os dois prontos para conversar' },
      { label: 'Quick Bot', caption: 'Envie uma base de conhecimento. Escreva um prompt. Publique.' },
      { label: 'Playground', caption: 'Nós, ramificações e conhecimento — no visual' },
      { label: 'Publicado', caption: 'Publicado e pronto para conversar' },
    ],
    analyst: [
      { label: 'Faça uma pergunta', caption: 'Pergunte aos seus dados em linguagem natural' },
      { label: 'Analisando', caption: 'Analisado no seu Mac' },
      { label: 'Gráfico e insight', caption: 'A resposta, o gráfico e como se chegou a eles' },
    ],
    ppt: [
      { label: 'Configure', caption: 'Tema, slides, idioma, tom e estilo' },
      { label: 'Revise o roteiro', caption: 'Edite o roteiro antes de gerar qualquer coisa' },
      { label: 'Veja o deck', caption: 'Um .pptx pronto e editável — no seu Mac' },
    ],
    pdf: [
      { label: 'Abra um PDF', caption: 'Artigos, relatórios, manuais e documentos digitalizados' },
      { label: 'Lendo', caption: 'Leitura local, página por página' },
      { label: 'Resposta com citação', caption: 'Cada resposta aponta a cláusula exata' },
    ],
    doc: [
      { label: 'Selecione um trecho', caption: 'Selecione o texto e diga o que você quer' },
      { label: 'Reescrevendo', caption: 'Reescrito direto no documento' },
      { label: 'Aceite ou rejeite', caption: 'Reescreva, refine, traduza — aceite ou rejeite' },
    ],
    meeting: [
      { label: 'Grave', caption: 'Transcrição ao vivo, neste Mac' },
      { label: 'Escolha o resultado', caption: 'Escolha o que gerar' },
      { label: 'Resumo', caption: 'Decisões e itens de ação, prontos para você' },
      { label: 'Itens de ação', caption: 'Responsáveis e prazos, com evidências' },
    ],
    vibe: [
      { label: 'Descreva', caption: 'Descreva uma interface em linguagem natural' },
      { label: 'Gerando', caption: 'Criado inteiramente neste Mac' },
      { label: 'Protótipo', caption: 'Clicável, com versões, em um único .html' },
      { label: 'Edição por clique', caption: 'Selecione qualquer parte e diga o que mudar' },
    ],
    translate: [
      { label: "Traduzir texto", caption: "Palavras em roxo vêm do seu glossário" },
      { label: "Traduzir um documento", caption: ".docx, .txt ou .md — o original não é alterado" },
      { label: "Glossário", caption: "Seu glossário mantém cada termo consistente" },
    ],
    private: [
      { label: 'Neste Mac', caption: 'Totalmente off-line. Nada sai deste dispositivo.' },
      { label: 'Mac Studio Cluster', caption: 'Modelos maiores — na sua infraestrutura' },
    ],
    org: [
      { label: 'Espaço da organização', caption: 'Espaço com a sua marca e apps feitos para a equipe' },
      { label: 'Plano Enterprise', caption: 'Membros só abrem os apps que você liberar' },
    ],
  },
};

export default ptBR;
